import { Field } from "components/commons";
import locale from "localization/en";
import { dateTimeFormat, formatAmount } from "utils";
import styles from "./expense-details.module.scss";
import { Skeleton } from "@material-ui/lab";
import { isNumber } from "lodash";
import { extractDirectoryWithFile } from "components/commons/select-file/select-file";
import { useState } from "react";
import { ImagePreview } from "components/modals";

const ViewExpense = ({ expense }) => {
  const [imageUrl, setImageUrl] = useState("");

  return (
    <>
      <Field label={locale.expenseId} horizontal labelClassName={styles.viewFieldLabel}>
        {expense ? expense?.expenseId : <Skeleton className={styles.skeletonSize} />}
      </Field>
      <Field label={locale.shiftDateAndTime} horizontal labelClassName={styles.viewFieldLabel}>
        {expense ? (
          expense?.shift ? (
            `${dateTimeFormat(expense?.shift?.startShift) ?? ""} - ${
              dateTimeFormat(expense?.shift?.endShift) ?? ""
            }`
          ) : (
            "--"
          )
        ) : (
          <Skeleton className={styles.skeletonSize} />
        )}
      </Field>
      <Field label={locale.expenseDateAndTime} horizontal labelClassName={styles.viewFieldLabel}>
        {expense ? (
          expense?.createdAt ? (
            dateTimeFormat(expense?.createdAt)
          ) : (
            "--"
          )
        ) : (
          <Skeleton className={styles.skeletonSize} />
        )}
      </Field>

      <Field label={locale.expenseType} horizontal labelClassName={styles.viewFieldLabel}>
        {expense ? expense?.type : <Skeleton className={styles.skeletonSize} />}
      </Field>
      {expense?.type === locale.nonInventoryItemRebates && (
        <>
          <Field label={locale.rebateType} horizontal labelClassName={styles.viewFieldLabel}>
            {expense ? expense?.rebateType : <Skeleton className={styles.skeletonSize} />}
          </Field>

          <Field label={locale.referenceNumber} horizontal labelClassName={styles.viewFieldLabel}>
            {expense ? expense?.referenceNumber : <Skeleton className={styles.skeletonSize} />}
          </Field>
        </>
      )}

      <Field label={locale.amount} horizontal labelClassName={styles.viewFieldLabel}>
        {expense ? (
          isNumber(expense?.amount) ? (
            formatAmount(expense?.amount || 0)
          ) : (
            "--"
          )
        ) : (
          <Skeleton className={styles.skeletonSize} />
        )}
      </Field>
      <Field label={locale.receipt} horizontal labelClassName={styles.viewFieldLabel}>
        {expense ? (
          expense?.imageUrl ? (
            expense.imageUrl.split(",").map((url, index) => {
              const trimmedUrl = url.trim();
              return (
                <div
                  key={index}
                  onClick={() => setImageUrl(trimmedUrl)}
                  className={styles.expenseReceiptLink}
                >
                  {extractDirectoryWithFile(trimmedUrl)}
                </div>
              );
            })
          ) : (
            "--"
          )
        ) : (
          <Skeleton className={styles.skeletonSize} />
        )}
      </Field>
      <Field label={locale.remarks} horizontal labelClassName={styles.viewFieldLabel}>
        {expense ? (
          expense?.remarks ? (
            expense?.remarks
          ) : (
            "--"
          )
        ) : (
          <Skeleton className={styles.skeletonSize} />
        )}
      </Field>
      <ImagePreview value={imageUrl} onClose={() => setImageUrl("")} />
    </>
  );
};

export default ViewExpense;
